import { createSlice } from '@reduxjs/toolkit';

import type { ModelosCartaArState } from '../../types/arModelosCarta';
import { fetchModelosCartaAr } from './actions';

export const LIMITE_PADRAO_MODELOS_CARTA = 20;

const initialState: ModelosCartaArState = {
  items: [],
  total: 0,
  page: 1,
  limit: LIMITE_PADRAO_MODELOS_CARTA,
  hasMore: false,
  search: '',
  loading: false,
  error: null,
  activeRequestId: null,
};

const modelosCartaArSlice = createSlice({
  name: 'secretariaArbitralModelosCarta',
  initialState,
  reducers: {
    limparModelosCartaAr() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchModelosCartaAr.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.activeRequestId = action.meta.requestId;
      })
      .addCase(fetchModelosCartaAr.fulfilled, (state, action) => {
        // A última busca vence: resposta de um termo já abandonado não pode
        // repovoar a lista por baixo de quem já digitou outro.
        if (state.activeRequestId !== action.meta.requestId) return;
        state.activeRequestId = null;
        state.loading = false;
        const termo = action.meta.arg.search?.trim() ?? '';
        // Página 1 RECOMEÇA a lista; as seguintes anexam. Sem isto, "Carregar mais"
        // e "buscar" competiriam pelo mesmo array e a busca nova apareceria emendada
        // no resultado da anterior.
        state.items =
          action.payload.page === 1
            ? action.payload.items
            : [...state.items, ...action.payload.items];
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
        state.hasMore = action.payload.hasMore;
        state.search = termo;
      })
      .addCase(fetchModelosCartaAr.rejected, (state, action) => {
        if (state.activeRequestId !== action.meta.requestId) return;
        state.activeRequestId = null;
        state.loading = false;
        state.error = action.payload ?? 'Erro ao carregar os modelos de carta';
      });
  },
});

export const { limparModelosCartaAr } = modelosCartaArSlice.actions;
export const secretariaArbitralModelosCartaReducer = modelosCartaArSlice.reducer;
